// extracted by mini-css-extract-plugin
export default {"download-link":"download-link__iO2AB"};